<template>
  <div id="zp">
    <div class="map">
        <vl-map :load-tiles-while-animating="true" :load-tiles-while-interacting="true"
          data-projection="EPSG:4326"
        >
      <vl-view :zoom.sync="zoom" :center.sync="center" :rotation.sync="rotation"></vl-view>

      <vl-geoloc @update:position="geolocPosition = $event">
        <template slot-scope="geoloc">
          <vl-feature v-if="geoloc.position" id="position-feature">
            <vl-geom-point :coordinates="geoloc.position"></vl-geom-point>
            <vl-style-box>
              <vl-style-icon src="_media/marker.png" :scale="0.4" :anchor="[0.5, 1]"></vl-style-icon>
            </vl-style-box>
          </vl-feature>
        </template>
      </vl-geoloc>
      <vl-layer-tile id="osm" opacity="0.2">
        <vl-source-osm opacity="0.2"></vl-source-osm>
      </vl-layer-tile>
      <vl-layer-tile id="wms">
      <vl-source-wms attributions="attribution" url="https://wmscache.luucy.ch/" layers="Hergiswil:strassen_buffer,Hergiswil:bebaubare_flaeche,Hergiswil:av_hergiswil" format="image/png"
                      style-name=""></vl-source-wms>
      </vl-layer-tile>
    </vl-map>
    </div>
    <div v-if="!simulationReady" class="docisnotready">
      <template>
        <div class="infotext">
          <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.91675 11.5V42.1666L15.3334 34.5L30.6668 42.1666L44.0834 34.5V3.83331L30.6668 11.5L15.3334 3.83331L1.91675 11.5Z" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.3333 3.83331V34.5" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><path d="M30.6667 11.5V42.1667" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <p v-if="processingStatus == 'NONE'" style="margin-top: 20px;">Die Berechnung der Potentiale kann hier gestartet werden</p>
        <p v-if="processingStatus == 'INPROGRESS'" style="margin-top: 20px;">Die Berechnung der Potentiale wurde gestartet. Wenn der Resultat fertig ist, werden Sie benachrichtigt.</p>
        <div style="color: black; margin-top: 30px; margin-bottom: 10px;">
          <v-btn
            depressed
            tile
            color="primary"
            :loading="sending"
            @click="startSimulation()"
            v-if="processingStatus == 'NONE'">Berechnung straten</v-btn>
        </div>
        <p v-if="processingStatus == 'INPROGRESS'">Gestartet: {{ started }}</p>
        <p v-if="processingStatus == 'NONE'">Die Berechung wird eine Längere Zeit in Anspruch nehmen und kann bis zu 48 Stunden dauern.</p>
        <Loader v-if="processingStatus == 'INPROGRESS'" />
        </div>
      </template>
    </div>

  </div>
</template>

<script>
import Loader from '@/components/Loader.vue'
import SimulationApi from '@/services/Simulation'

export default {
  name: 'simulation',
  mounted () {
    this.refreshSimulationState()
  },
  data () {
    return {
      unitId: this.$unit.uuid,
      zoom: 12,
      center: [8.312634, 46.987279],
      rotation: 0,
      simulationReady: false,
      sending: false,
      loading: false,
      processingStatus: this.$unit.processingStatus
    }
  },
  computed: {
    started () {
      return new Date(this.$unit.processingStarted).toLocaleString()
    }
  },
  methods: {
    async startSimulation () {
      this.sending = true
      const responce = await SimulationApi.startSimulation(this.$unit.uuid)

      if (responce) {
        console.log(responce)
        this.processingStatus = responce.data.processingStatus
        this.processingStarted = responce.data.processingStarted
        this.$unit.processingStatus = responce.data.processingStatus
        this.$unit.processingStarted = responce.data.processingStarted
        this.sending = false
      }
    },
    refreshSimulationState () {
      // TODO
    }
  },
  components: [
    Loader
  ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.map {
    height: 100%;
}
#zp {
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    position: absolute;
}
.docisnotready {
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.9;
  position: absolute;
  align-content: center;
  justify-content: center;
  display: flex;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 1000;
  padding: 10%;
}
.infotext {
  max-width: 300px;
  text-align: center;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Simulation.vue